import type { ActionMeta } from '@lokalise/louis';
import { Label, Select } from '@lokalise/louis';

import type { Option } from './types';

interface FilterDataProps {
    value: readonly Option[];
    options: readonly Option[];
    onChange: (value: readonly Option[], actionMeta: ActionMeta<Option>) => void;
}

const FilterData = ({ value, options, onChange }: FilterDataProps) => (
    <Label text="Data" id="FilterData">
        <Select
            value={value}
            options={options}
            isMulti
            onChange={onChange}
            aria-labelledby="FilterData"
            placeholder="All strings"
        />
    </Label>
);

export default FilterData;
